import styled from '@emotion/styled'
import type { PaymentProcessorKind } from '../generated/graphql'
import { getRoutableUrl } from '../utils/util'

interface RoutableLinkIconProps {
  paymentProcessorKind: PaymentProcessorKind
  externalRefId: string
}

const StyledLink = styled('a')({
  cursor: 'pointer',
  '&:hover': {
    filter: 'saturate(0.4)',
  },
})

export default function RoutableLinkIcon({ paymentProcessorKind, externalRefId }: RoutableLinkIconProps) {
  const routableUrl =
    paymentProcessorKind && externalRefId
      ? `${getRoutableUrl(paymentProcessorKind)}/dashboard/payments/payables/all/${externalRefId}/item`
      : null

  if (!routableUrl) {
    return null
  }

  return (
    <StyledLink href={routableUrl} target="_blank" rel="noopener noreferrer" onClick={e => e.stopPropagation()}>
      <img
        src="/routableLogo.png"
        alt="View in Routable"
        width={20}
        height={20}
        style={{ display: 'block', borderRadius: '50%' }}
      />
    </StyledLink>
  )
}
